export const globalSettings = {
	// shadowQuality: 1024, // default 512
	shadowQuality: 2048, // default 512
	// maxZoom: 50, // @orto cam
	// minZoom: 2, // @orto cam
	// minDistance: 500, // @orto cam
	// maxDistance: 3000, // @orto cam
	minDistance: 50,
	maxDistance: 500,
	zoomFactor: 1.5, // How much it zoom in/out (2 = double distance each click)
	minPolarAngle: 0, // Min vertical orbit ([0-90], 0 = side view, 90 = top view)
	maxPolarAngle: 90, // Max vertical orbit ([0-90], 0 = side view, 90 = top view)
	pan: false,
	productName: 'unit-',
	availableVisible: false, // Only work for SHOW_AVAILABLES_ONLY disabled
	environmentIntensity: .4,
	// environmentIntensity: .8,
	camera: {
		// near: .1, // Min distance when model gets clip
		near: 5, // Min distance when model gets clip
		// far: 2000, // Max distance when model gets clip
		far: 1750, // Max distance when model gets clip
	},
	model: {
		position: {
			x: 0,
			y: 0,
			z: 0,
		},
		scale: 1,
		rotation: 0,
		hitboxScale: 1,
	},
	landscape: {
		type: "real",
		lat: 0,
		lon: 0,
		height: 0,
		opacity: 1, // for type real only
		emissiveIntensity: 0, // for type real only
		clip: {
			type: "bbox",
			// dimension: {
			// 	x: 10,
			// 	y: 70,
			// 	z: 10,
			// },
			// position: {
			// 	x: 0,
			// 	y: 0,
			// 	z: 0,
			// },
			// rotation: 0
		}
	},
	defaultView: {
		// x: 1, // @orto cam
		// y: 1, // @orto cam
		// z: .7 , // @orto cam
		x: 0,
		y: 0,
		z: -1,
		angle: {
			x: 0, // Orientation:  Angle in degree from north (0 = north, 90 = east, 180 = south, 270 = west)
			y: 45,	// [0-90] Angle in degree from ground (90 = ground, 0 = top)
		},
		distance: 200, // @perp cam
		zoom: 4, // @orto cam
		target: {
			x: 0, 
			y: 0, 
			z: 0, 
		},
		time: 'noon',
	},
	hemisphereLight: {
		color: {
			color: 0xffffff,
			opacity: 1,
		},
		groundColor: {
			color: 0xffffff,
			opacity: 1,
		},
		intensity: 0, // default: 1
	},
	sunLight: {
		intensity: 4,
		color: {
			color: 0xffffff,
			opacity: 1,
		},
	},
	lights: {
		morning: {
			intensity: 4,
			color: 0xff0000, // 0xfffed9,
			color: 0xffffff,
			position: {
				x: 150,
				y: 150,
				z: 50, // season angle
			},
			sky: {
				x: -72,
				// y: 43.5, // real match with sun light (this.sun)
				y: 20,
				// y: 5,
				exposure: .5,
			},
			// fog: 0xafbcc5,
			fog: 0xdfe3e4,
		},
		noon: {
			intensity: 4,
			color: 0xffffff,
			position: {
				// x: 0,
				x: 50, // Not exactly noon, give a sligh angle to cast shadows
				y: 200,
				z: 50, // season angle
			},
			sky: {
				x: 0,
				y: 76,
				exposure: .5,
			},
			// fog: 0xafbcc5,
			fog: 0xdfe3e4,
		},
		evening: {
			intensity: 4,
			color: 0x0000ff, // 0xffe2c7,
			color: 0xffffff,
			position: {
				x: -150,
				y: 150,
				z: 50, // season angle
			},
			sky: {
				x: 72,
				// y: 43.5, // real match with sun light (this.sun)
				y: 20,
				// y: 5,
				exposure: .5,
			},
			// fog: 0xafbcc5,
			fog: 0xdfe3e4,
		},
	},
	lerp: {
		sun: {
			speed: .05,
			threshold: 1,
		},
		default: {
			speed: .075,
			threshold: .01,
		}
	},
	materials: {
		hidden: {
			transparent: true,
			// visible: true,
			color: '#ff9900',
			emissive: '#ff9900',
			emissiveIntensity: .5,
			opacity: .4,
		},
		unavailable: {
			transparent: true,
			// visible: true,
			color: '#a02626',
			emissive: '#ff0000',
			emissiveIntensity: .5,
			opacity: .4,
		},
		filtered: {
			transparent: true,
			// visible: true,
			color: '#bbbbbb',
			emissive: '#bbbbbb',
			emissiveIntensity: .5,
			opacity: .6,
		},
		available: {
			transparent: true,
			// visible: true,
			color: '#ffffff',
			emissive: '#ffffff',
			opacity: .5,
			emissiveIntensity: .8,
		},
		highlighted: {
			transparent: true,
			// visible: true,
			color: '#ffffff',
			emissive: '#ffffff',
			emissiveIntensity: 3,
			opacity: 1,
		}
	},
	materialsNohitbox: {
		hidden: {
			emissive: '#c99d00',
			emissiveIntensity: .75,
		},
		unavailable: {
			emissive: '#ff0000',
			emissiveIntensity: .75,
		},
		filtered: {
			map: null,
			metalnessMap: null,
			normalMap: null,
			roughnessMap: null,
			metalness: 1,
			roughness: .15,
			transparent: true,
			opacity: .75,
		},
		highlighted: {
			emissive: '#ffffff',

		}
	}
};

export const developmentSettings = {
	"boilerplate": {
		"productName": "unit-",
		"minDistance": 80,
		"maxDistance": 320,
		"model": {
			"rotation": 0,
			"scale": 1,
			"position": {
				"x": 0,
				"y": 0,
				"z": 0
			}
		},
		"landscape": {
			"lat": 0,
			"lon": 0,
			"height": 0
		},
		"defaultView": {
			"distance": 200,
			"angle": {x: 0, y: 45}
		}
	},
	"korall": {
		"minDistance": 70,
		"maxDistance": 220,
		"minPolarAngle": 25,
		"maxPolarAngle": 80,
		"defaultView": {
			"distance": 155,
			// "angle": {x: 60, y: 30}
			"angle": {x: 240, y: 30}
		},
		"model": {
			// "rotation": 154,
			// "rotation": 333,
			"rotation": 154+180,
			"scale": 1,
			// "position": {
			// 	"x": -4.8,
			// 	"y": 1.5,
			// 	"z": 3.4
			// }
			"position": {
				"x": 4.5,
				"y": 1.5,
				"z": -4.15
			}
		},
		"landscape": {
			"lat": 36.570717,
			"lon": -4.597703,
			"height": 85,
			"opacity": 1,
			"clip": {
				"type": "polygon",
				"points" : [
					[-0.34100474197993513,-63.41328020067357],
					[59.45574792585842,-13.304189945504744],
					[7.417073090729467,49.556517958512664],
					[-43.035188938318015,1.5331282578987127]
				]
			},
		}
	},
	"torre-armonia": {
		"productName": "unit_t",
		"minDistance": 60,
		"maxDistance": 120,
		"minPolarAngle": 35,
		"maxPolarAngle": 70,
		"defaultView": {
			"distance": 100,
			// "angle": {x: 115, y: 40}
			"angle": {x: 285, y: 40}
		},
		"model": {
			// "rotation": 180,
			// "hitboxScale": 2,
			"rotation": 0,
			"scale": 1.008,
			// "position": {
			// 	"x": -0.65,
			// 	"y": -2,
			// 	"z": -2.75
			// },
			"position": {
				"x": 4.35,
				"y": -2,
				"z": 1.95
			},
		},
		"landscape": {
			// "lat": 43.539881,
			// "lon": -5.707667,

			"lat": 43.539869,
			"lon": -5.707708,
			
			"height": 70,
			// "opacity": .5,
			"clip": {
				"type": "polygon",
				"points": [
					[46.36939042863266,12.318108072234894],
					[-40.17914606626655,48.66550604265885],
					[-57.05984906818643,9.612451002293737],
					[-36.328852441167236,-32.23381238020581],
					[0.047631551786796344,-73.9368875967982],
					[1.9772300600512915,-74.96516109630026],
					[4.4818179243302865,-73.91819159499597]
				]
			},
		}
	},
	"ancor": {
		"pan": true,
		"minDistance": 25,
		"maxDistance": 390,
		"minPolarAngle": 40,
		"availableVisible": true,
		// "maxPolarAngle": 70,
		"defaultView": {
			"distance": 280,
			"angle": {x: 200, y: 40}
		},
		"model": {
			// "rotation": 175.3,
			"rotation": 354.7,
			"scale": .37,
			// "position": {
			// 	"x": 34.6,
			// 	"y": -2.65,
			// 	"z": 10.15
			// },
			"position": {
				"x": -53,
				"y": -2.65,
				"z": -90
			}
		},
		"landscape": {
			"lat": 28.145032,
			"lon": -16.448315,
			
			"lat": 28.144320,
			"lon": -16.448114,

			"height": 105,
			"clip": {
				"type": "polygon",
				"points": [
					[-89.26615107666073,-130.75068826222324],
					[-25.393582460361216,-131.74145855218265],
					[-19.623581288249618,-129.9180771117069],
					[8.774219841070204,-109.5885952776324],
					[11.066332562727151,-103.1688554500702],
					[1.0013612239568115,6.4247276373769955],
					[-93.43845351392237,-92.30717784471464],
				]
			},
		},
		"materials": {
			"available": {
				"color": "#2eaa66",
				"emissive": "#2eaa66"
			}
		}
	},
	"demo": {
		"defaultView": {
			"distance": 10
		},
	},
	"jose-garrido": {
		"minDistance": 50,
		"maxDistance": 140,
		"minPolarAngle": 40,
		"defaultView": {
			"distance": 68,
			"angle": {x: 90, y: 50}
		},
		"model": {
			"rotation": 10,
			"scale": 1.01,
			// "scale": 1.025,
			"position": {
				"x": .1,
				"y": .5,
				"z": -1.4
			}
		},
		"landscape": {
			"lat": 40.392797,
			"lon": -3.734944,
			"height": 684, // lowpoly
			"height": 675, // photorealistic
			"opacity": .85,
			"emissiveIntensity": .3,
			"clip": {
				"dimension": {
					"x": 46,
					"z": 15.65,
					"y": 70.2
				},
				"position": {
					"x": .4,
					"z": -1.6,
					"y": 0
				},
				"rotation": 10
			}
		},
	},
	"lopez-de-hoyos": {
		"productName": "floor0",
		"minDistance": 35,
		"maxDistance": 65,
		// "maxDistance": 500,
		"minPolarAngle": 25,
		"defaultView": {
			"distance": 55,
			"angle": {x: 85, y: 35}
		},
		"model": {
			"rotation": 137,
			"scale": 1.769,
			"position": {
				"x": 1.55,
				"y": 4.5,
				"z": 5.1
			}
		},
        "landscape": {
			"lat": 40.45530300087962,
			"lon": -3.662601844140762,
            "height": 736,
			"clip": {
				"type": "polygon",
				"points": [	
					// [32.813815999595974, 73.82820893692146],
					// [-0.5974229613070428, 42.796218829741306],
					// [-14.36938106722824, -3.578036128265964],
					// [15.42811982795534, -34.33321379472675]
						
					// [30.309552949176044, 65.35812474715007],
					// [-0.7904193674050521, 36.262530383831596],
					// [-13.764932307939537, -2.475673397958173],
					// [17.381056198120916, -36.03285347920341]

					[27.020911223357206, 47.165727444208734],
					[-6.585283782106664, 16.007423337235778],
					[-13.771854957428648, -2.543655355115586],
					[17.6635172225268, -36.17586239931092],
					[22.73913534278138, 15.896182545774803]
				],
				"rotation": 137,
				"dimension": {
					"x": 27.95,
					"z": 14.8,
					"y": 37.45
				},
				"position": {
					"x": 3.3,
					"z": 1.95,
					"y": 0
				}
			}
        }
	},
	'parque-vega': {
		pan: true,
		maxPolarAngle: 70,
		model: {
			rotation: 329,
			scale: .92,
			hitboxScale: 1.015,
			position: {
				x: 27.2,
				y: -1.5,
				z: 10.5,
			},
		},
		landscape: {
			lat: 43.4891604,
			lon: -5.6496228,
			height: 104,
			clip: {
				dimension: {
					x: 177.7,
					z: 61.6,
					y: 70,
				},
				position: {
					x: 1,
					z: 9.4,
					y: -2,
				},
				rotation: 149
			}
		},
	},
	"torrenova": {
		"pan": true,
		"minDistance": 100,
		"maxDistance": 250,
		"minPolarAngle": 30,
		"maxPolarAngle": 70,
		"defaultView": {
			"distance": 130,
			// "angle": {x: 130, y: 35}
			"angle": {x: 310, y: 35}
		},
		"model": {
			// "rotation": 180,
			// "position": {
			// 	"x": 50,
			// 	"y": 1.35,
			// 	"z": 25.75,
			// },
			"rotation": 0,
			// "position": {
			// 	"x": -45.9,
			// 	"y": 1.35,
			// 	"z": -20.65,
			// },
			"position": {
				"x": -36.1,
				"y": 1.35,
				"z": -16.05,
			},
		},
		"landscape": {
			// "lat": 37.389538,
			// "lon": -5.962924,
			
			// "lat": 37.389544,
			// "lon": -5.963016,
			
			// "lat": 37.389562,
			// "lon": -5.963064,
			
			// "lat": 37.389602,
			// "lon": -5.963011,
			
			"lat": 37.389614,
			"lon": -5.963051,

			// "opacity": .6,
			"height": 64,
			"clip": {
				"type": "polygon",
				"points" : [
					[-235.09250096813827,95.23206808323441],
					[-313.6088373829425,-34.825145494967565],
					[-56.09493137751249,-291.20968912172077],
					[-12.672617913911377,-289.1857264775524],
					[106.09580131913464,-162.7132557300715],
					[131.9288396670359,-113.94155699328223],
					[135.84618847441365,-63.74274239591003],
					[135.05879074791565,93.40071061027733]
				]
			},
		}
	},
	"monga": {
		"minDistance": 0,
		"maxDistance": 320,
		"pan": true,
		"model": {
			"rotation": 0,
			"scale": 1,
			"position": {
				"x": 0,
				"y": 0,
				"z": 0
			}
		},
		"landscape": {
			"lat": 43.367384,
			"lon": -5.486628,
			"height": 306,
			"clip": false,
			"clip": {
				"type": "polygon",
				"points": [
					[5.445071704310269,-6.633216042301207],
					[6.464549323117489,-6.631550400907605],
					[6.488317940744267,-3.6164912813183188],
					[5.415384822037873,-3.592606132295588]
				]
			}
		},
		"defaultView": {
			"distance": 10,
			"angle": {x: 0, y: 45}
		}
	}
}